import ModalDetailBooking from "./ModalDetailBooking";
import ModalEditBooking from "./ModalEditBooking";

export { ModalDetailBooking, ModalEditBooking };



// WEBPACK FOOTER //
// src/components/Dashboard/ModalBooking/index.js